export default __webpack_public_path__ + "static/media/img-elizabethyapura.4e1ab39e.jpg";